import { HStack, Icon, IconButtonWithTooltip, Text } from 'design-system';
import { usePageParams } from 'hooks/use-page-params';
import { formatMonthLabel, getMonthParam, shiftMonth } from 'pages/reconciliation/utils/month';
import { FiCalendar, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

export const MonthSwitcher = () => {
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();
  const month = getMonthParam(params);

  const goToMonth = (delta: 1 | -1) => {
    setPageParams({ ...params, month: shiftMonth(month, delta), page: undefined });
  };

  return (
    <HStack
      spacing={0}
      bg='white'
      border='1px solid'
      borderColor='gray.200'
      borderRadius='lg'
      boxShadow='sm'
      overflow='hidden'>
      <IconButtonWithTooltip
        size='sm'
        label='Previous month'
        aria-label='previous-month-btn'
        Icon={<Icon as={FiChevronLeft} />}
        variant='ghost'
        borderRadius='none'
        onClick={() => goToMonth(-1)}
      />
      <HStack spacing='xs' px='md' h='40px' borderLeft='1px solid' borderRight='1px solid' borderColor='gray.100'>
        <Icon as={FiCalendar} color='gray.500' boxSize='14px' />
        <Text fontWeight='semibold' minW='90px' textAlign='center' whiteSpace='nowrap'>
          {formatMonthLabel(month)}
        </Text>
      </HStack>
      <IconButtonWithTooltip
        size='sm'
        label='Next month'
        aria-label='next-month-btn'
        Icon={<Icon as={FiChevronRight} />}
        variant='ghost'
        borderRadius='none'
        onClick={() => goToMonth(1)}
      />
    </HStack>
  );
};
